import React, { useState, useEffect, useCallback } from "react";
import { useRouteMatch } from "react-router-dom";
import GetPolicySummaryFormPas from "../services/GetPolicySummaryFormPas";
import GetPolicySummaryFormMis from "../services/GetPolicySummaryFormMis";
import Title from "../components/PolicySummary/Title";
import PolicyDetails from "../components/PolicySummary/PolicyDetails";
import ProductDetails from "../components/PolicySummary/ProductDetails";
import ApplicantDetails from "../components/PolicySummary/ApplicantDetails";
import BenefitDetails from "../components/CoC-Details/BenefitDetails";
import ConditionDetails from "../components/PolicySummary/ConditionDetails"
import PolicyLapse from "../components/PolicySummary/Lapse"
import InvestmentDetails from "../components/PolicySummary/InvestmentDetails";
import { coc, printIcon } from "../components/Shared/Styles";
import { GelIcon } from "@tal-gel/components";
import useQuery from "../hooks/useQuery";

const Print = () => {
  let printContents = document.getElementById("PolicySummary").innerHTML;
  let myWindow = window.open("PolicySummary", "_blank");
  myWindow.document.write("<html><head><title></title>");
  myWindow.document.write('<style type="text/css" media="print"> @page { size: auto; margin: 40px; }</style>');
  myWindow.document.write("</head><body style='width: 1020px; font-family: Pluto Sans Condensed, Arial, sans-serif; font-size: 14px;'>");
  myWindow.document.write(printContents);
  myWindow.document.write("</body></html>");
  myWindow.focus();
  myWindow.window.print();
  myWindow.close();
};

export default function PolicySummary(props) {
  let query = useQuery();
  let { url } = useRouteMatch();

  const [policyDetails, setPolicyDetails] = useState();
  const [benefitDetails, setBenefitDetails] = useState();
  const [productDetails, setProductDetails] = useState();
  const [applicantDetails, setApplicantDetails] = useState();
  const [conditionDetails, setConditionDetails] = useState();
  const [policyLapse, setPolicyLapse] = useState();

  const [policyNumber] = useState(query.get("policyNumber"));
  const [policyStatus] = useState(query.get("policyStatus"));
  const [distributorNo] = useState(query.get("distributorNo"));

  const retrievePolicySummaryResult = useCallback(async () => {
    if (policyStatus === null || undefined) {
      policyStatus = "in force";
    }

    if (policyStatus.toLowerCase() === "in suspense" || policyStatus.toLowerCase() === "proposal") {
      const result = await GetPolicySummaryFormPas(
        policyNumber,
        distributorNo
      );

      if (result) {
        console.log('resultPS', result);

        if (result.policyDetails) {
          await setPolicyDetails(result.policyDetails);
        }

        if (result.productDetails) {
          await setProductDetails(result.productDetails);
        }

        if (result.applicantDetails) {
          await setApplicantDetails(result.applicantDetails);
        }

        if (result.benefitDetails) {
          await setBenefitDetails(result.benefitDetails);
        }

        if (result.conditionDetails) {
          await setConditionDetails(result.conditionDetails);
        }

        if (result.policyLapse) {
          await setPolicyLapse(result.policyLapse);
        }
      }
    } else {
      console.log('resultPS', result);
      const result = await GetPolicySummaryFormMis(
        policyNumber,
        distributorNo
      );

      if (result) {
        if (result.policyDetails) {
          await setPolicyDetails(result.policyDetails);
        }

        if (result.productDetails) {
          await setProductDetails(result.productDetails);
        }

        if (result.applicantDetails) {
          await setApplicantDetails(result.applicantDetails);
        }

        if (result.benefitDetails) {
          await setBenefitDetails(result.benefitDetails);
        }

        if (result.conditionDetails) {
          await setConditionDetails(result.conditionDetails);
        }

        if (result.policyLapse) {
          await setPolicyLapse(result.policyLapse);
        }
      }
    }
  }, []);

  useEffect(() => {
    retrievePolicySummaryResult();
  }, [retrievePolicySummaryResult]);

  return (
    <div>
      <body>
        <div style={printIcon}>
          <GelIcon onClick={Print} name="ActionsToolsPrint" brand />
          <div style={{ marginLeft: "7px" }}>Print</div>
        </div>

        <div id="PolicySummary" style={coc}>
          <div style={{ marginBottom: "40px" }}>
            {productDetails && <Title productDetails={productDetails} />}
          </div>

          <div style={{ marginBottom: "30px" }}>
            <span>
              {policyDetails && <PolicyDetails policyDetails={policyDetails} />}
            </span>
          </div>

          <div style={{ marginBottom: "30px" }}>
            <span>
              {productDetails && (
                <ProductDetails productDetails={productDetails} />
              )}
            </span>
          </div>

          <div style={{ marginBottom: "30px" }}>
            <span>
              {applicantDetails && (
                <ApplicantDetails applicantDetails={applicantDetails} />
              )}
            </span>
          </div>

          <div style={{ marginBottom: "30px" }}>
            <span>
              {benefitDetails && (
                <BenefitDetails benefitDetails={benefitDetails} />
              )}
            </span>
          </div>

          <div style={{ marginBottom: "30px" }}>
            <span>
              {conditionDetails && (
                <ConditionDetails conditionDetails={conditionDetails} />
              )}
            </span>
          </div>

          <div style={{ marginBottom: "30px" }}>
            <span>
              {policyLapse && (
                <PolicyLapse policyLapse={policyLapse} />
              )}
            </span>
          </div>

          <div style={{ marginBottom: "30px" }}>
            <span>
              <InvestmentDetails />
            </span>
          </div>
        </div>
      </body>
    </div>
  );
}
